/**
 * Estado da vista do mapa (centro/zoom/resolução), atualizado no `moveend`.
 * Serve ao link compartilhável (c, z) e à qualidade automática.
 */
import { create } from 'zustand';

export interface ViewState {
  /** Centro em lon/lat (graus), ou null antes de o mapa existir. */
  center: [number, number] | null;
  zoom: number | null;
  /** Unidades do mapa por pixel CSS. */
  resolution: number | null;
  /** A vista é a inicial ("Amazônia") — não precisa ir para o link. */
  isHome: boolean;
  /** Centro (lon/lat) pedido pelo link, aplicado quando o mapa for criado. */
  initialCenter: [number, number] | null;
  /** Zoom pedido pelo link. */
  initialZoom: number | null;
  /**
   * Enquadramento inicial no celular em pé: "preencher" aproxima até a imagem
   * ocupar a altura da tela (sem faixa preta); "setor" mostra a Amazônia
   * inteira mesmo com faixas.
   */
  fillMode: 'preencher' | 'setor';
}

export const useViewStore = create<ViewState>()(() => ({
  center: null,
  zoom: null,
  resolution: null,
  isHome: true,
  initialCenter: null,
  initialZoom: null,
  fillMode: 'preencher',
}));
